var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBook(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4 5C4 3.34315 5.34315 2 7 2H17C18.6569 2 20 3.34315 20 5V12.5V14.5V15.8614C20 15.864 20 15.8665 20 15.8691V16.3118C20 16.876 19.5426 17.3333 18.9784 17.3333C18.3404 17.3333 17.8231 17.8506 17.8231 18.4886V18.8232C17.8231 19.4731 18.35 20 19 20C19.5523 20 20 20.4477 20 21C20 21.5523 19.5523 22 19 22H16H12H7.5C5.567 22 4 20.433 4 18.5V5ZM16.0482 20C15.903 19.636 15.8231 19.2389 15.8231 18.8232V18.4886C15.8231 17.9503 15.9579 17.4434 16.1956 17H7.5C6.67157 17 6 17.6716 6 18.5C6 19.3284 6.67157 20 7.5 20H12H16H16.0482ZM18 13.9927C18 13.9952 18 13.9976 18 14V15H7.5C6.9632 15 6.45463 15.1208 6 15.3368V5C6 4.44772 6.44772 4 7 4H17C17.5523 4 18 4.44772 18 5V12.5V13.9927Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBook);
export default __webpack_public_path__ + "static/media/book.7be724a45eef633f59ab2ebc8d271f4d.svg";
export { ForwardRef as ReactComponent };